import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { blogArticles, relatedMap } from '../data/blogArticles';

const categoryColors = {
  'Payment Terms': 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300',
  'UK VAT': 'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300',
  'UK Invoicing': 'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300',
  'GST India': 'bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300',
  'Australia': 'bg-sky-100 dark:bg-sky-900/30 text-sky-700 dark:text-sky-300',
  'Freelancing': 'bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300',
  'International': 'bg-violet-100 dark:bg-violet-900/30 text-violet-700 dark:text-violet-300',
  'Basics': 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300',
};

export default function RelatedArticles({ current }) {
  const slugs = relatedMap[current] || [];
  const articles = slugs
    .map(slug => blogArticles.find(a => a.slug === slug))
    .filter(Boolean);

  if (articles.length === 0) return null;

  return (
    <section className="mt-14 pt-10 border-t border-gray-100 dark:border-gray-800">
      <h2 className="text-lg font-bold text-gray-900 dark:text-white mb-5">Related Articles</h2>
      <div className="grid gap-4 sm:grid-cols-3">
        {articles.map(({ slug, title, excerpt, category }) => (
          <Link
            key={slug}
            to={slug}
            className="group block p-4 rounded-xl border border-gray-100 dark:border-gray-800 hover:border-blue-200 dark:hover:border-blue-800/50 hover:bg-gray-50 dark:hover:bg-gray-900/40 transition-colors"
          >
            <span className={`inline-block text-xs font-semibold px-2 py-0.5 rounded-full mb-2 ${categoryColors[category] || categoryColors['Basics']}`}>
              {category}
            </span>
            <p className="font-medium text-sm text-gray-900 dark:text-white leading-snug mb-1 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">
              {title}
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-400 leading-relaxed line-clamp-2">{excerpt}</p>
            <span className="mt-2 flex items-center gap-1 text-xs text-blue-600 dark:text-blue-400 font-medium">
              Read more <ArrowRight className="w-3 h-3" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}
